/**
 * Identifiants des étapes du parcours de souscription d'un contrat collectif.
 * Les valeurs string sont alignées sur les constantes back de
 * `Codes.EtapesSouscriptionContratGroupe.cs` (FR) — les noms TS sont en EN.
 */
export const GroupContractStepIdentifier = {
  Subscriber: 'SOUSCRIPTEUR',
  Products: 'PRODUITS',
  Brokers: 'COURTIERS',
  Contractualization: 'CONTRACTUALISATION',
  Active: 'ACTIF',
} as const;

export type GroupContractStepIdentifier =
  typeof GroupContractStepIdentifier[keyof typeof GroupContractStepIdentifier];

/**
 * Aligné sur le back `Codes.StatutsEtape` (`pending` / `current` / `completed`).
 */
export const StepStatus = {
  Pending: 'pending',
  Current: 'current',
  Completed: 'completed',
} as const;

export type StepStatus = typeof StepStatus[keyof typeof StepStatus];

export interface GroupContractStepDto {
  identifier: GroupContractStepIdentifier;
  name: string;
  status: StepStatus;
}

export interface GroupContractProcessResponse {
  groupContractId: string;
  type: 'GROUP' | 'CADRE';
  steps: GroupContractStepDto[];
  currentStepIdentifier: GroupContractStepIdentifier;
  highestAccessibleStep: GroupContractStepIdentifier;
  isProcessCompleted: boolean;
}
